export default __webpack_public_path__ + "images/wbtc_0b63ba.svg";